import React, { forwardRef } from 'react';
import ChevronLeftPairedWithText from '../text-pairing/ChevronLeft';
const ChevronLeft = forwardRef((props, ref) => (React.createElement("svg", { viewBox: "0 0 14 24", height: "1em", role: "img", ref: ref, ...props },
    React.createElement("path", { d: "m.25 12 12 12 1.058-1.058L2.365 12 13.308 1.057 12.25 0z", fill: "currentColor" }))));
ChevronLeft.displayName = 'ChevronLeft';
// @ts-ignore;
const iconData = {
    glyph: ChevronLeft,
    group: 'navigation',
    textPairingGlyph: ChevronLeftPairedWithText,
    followDirection: true,
};
export default iconData;
export const hookLeft = {
    ...iconData,
    alias: true,
    aliasFor: 'chevronLeft',
    textPairingGlyph: ChevronLeftPairedWithText,
    followDirection: true,
};
